var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var OrangeSVGAbstractElement = require('./orange-svg-abstract-element');
var OrangeSVGRect = /*#__PURE__*/function (_OrangeSVGAbstractEle) {
  "use strict";

  _inherits(OrangeSVGRect, _OrangeSVGAbstractEle);
  var _super = _createSuper(OrangeSVGRect);
  /**
   *
   * @param {number} top_left_x X coordinate of the top left corner
   * @param {number} top_left_y Y coordinate of the top left corner
   * @param {number} width Rectangle width
   * @param {number} height Rectangle height
   * @param {?string} color Rectangle background color
   */
  function OrangeSVGRect(top_left_x, top_left_y, width, height) {
    var _this;
    var color = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    _classCallCheck(this, OrangeSVGRect);
    _this = _super.call(this);
    _this._top_left_x = top_left_x;
    _this._top_left_y = top_left_y;
    _this._width = width;
    _this._height = height;
    _this._color = color;
    return _this;
  }

  /**
   * Name of the tag
   *
   * @type string
   * @static
   * @abstract
   */
  _createClass(OrangeSVGRect, [{
    key: "_do_render",
    value:
    /**
     * Prepare render data
     *
     * @private
     */
    function _do_render() {
      var args = {
        'x': this._top_left_x,
        'y': this._top_left_y,
        'width': this._width,
        'height': this._height
      };
      if (this._color !== null) {
        args['fill'] = this._color;
      }
      return {
        args: args
      };
    }
  }], [{
    key: "tag",
    get: function get() {
      return 'rect';
    }
  }]);
  return OrangeSVGRect;
}(OrangeSVGAbstractElement);
module.exports = OrangeSVGRect;